import { Preferences } from '@capacitor/preferences';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { usePlatform } from 'hooks';

export const AUTH_TOKEN_STORE_NAME = 'qb_app_auth_token';
export const AUTH_TOKEN_QUERY_KEY = [AUTH_TOKEN_STORE_NAME] as const;

export const useGetAuthToken = () => {
  const { isWeb } = usePlatform();
  return useQuery<string | null>({
    queryKey: [...AUTH_TOKEN_QUERY_KEY, 'web: ' + isWeb],
    queryFn: async () => {
      if (isWeb) return null; // Auth is cookie-based on web
      const { value } = await Preferences.get({ key: AUTH_TOKEN_STORE_NAME });
      return value ?? null;
    },
    staleTime: Infinity,
  });
};

export const useSetAuthToken = () => {
  const queryClient = useQueryClient();
  const { isWeb } = usePlatform();
  return useMutation<string | null, Error, string | null>({
    mutationFn: async (token: string | null) => {
      if (isWeb) return null; // Auth is cookie-based on web
      if (token === null) {
        await Preferences.remove({ key: AUTH_TOKEN_STORE_NAME });
      } else {
        await Preferences.set({ key: AUTH_TOKEN_STORE_NAME, value: token });
      }
      return token;
    },
    onSuccess: (token) => {
      queryClient.setQueryData(AUTH_TOKEN_QUERY_KEY, token);
    },
  });
};
